module.exports = __webpack_public_path__ + "img/parks-1-3.ad8b70e4.jpg";